import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Events/MembersMeeting/components/SectionAgenda/SectionAgenda.module.scss';

const cn = classNames.bind(styles);

const SectionAgenda = (): ReactElement => {
  return (
    <section className={cn('agenda-section')}>
      <div className={cn('agenda-section__image-box--tablet')}>
        <img
          className={cn('agenda-section__image')}
          src="/images/pages/Events/MembersMeeting/speakers.svg"
          alt="speakers"
        />
      </div>
      <div className={cn('container')}>
        <div className={cn('agenda-section__box')}>
          <div className={cn('agenda-section__image-box--desktop')}>
            <img
              className={cn('agenda-section__image')}
              src="/images/pages/Events/MembersMeeting/speakers.svg"
              alt="speakers"
            />
          </div>
          <div className={cn('agenda-section__image-box--mobile')}>
            <img
              className={cn('agenda-section__image')}
              src="/images/pages/Events/MembersMeeting/speakers.svg"
              alt="speakers"
            />
          </div>
        </div>
        <div className={cn('agenda-section__info-box')}>
          <h5 className={cn('agenda-section__info-title')}>This month we'll hear:</h5>
          <ul className={cn('agenda-section__info-list')}>
            <li className={cn('agenda-section__info-list-item')}>
              Presentation of DFA Premium Sukhin Global Logistics (India)
            </li>
          </ul>
          {/*<p className="agenda-section__info-paragraph">*/}
          {/*    And you'll hear from our guest speaker, Chris Tiffany,*/}
          {/*    who will be talking about our upcoming DFA event in Thailand.*/}
          {/*</p>*/}
          <div className={cn('agenda-section__buttons-box')}>
            <a
              className={cn('agenda-section__button')}
              rel="nofollow"
              href="https://assets-eur.mkt.dynamics.com/97490e54-fad8-444f-95d3-13ab26ee6605/digitalassets/standaloneforms/34a4ab24-c945-f011-877a-6045bde15d9b"
            >
              Click here to register
              <svg viewBox="0 0 10 10" aria-hidden="true">
                <path d="M1 5h7"></path>
                <path d="M2 1l4 4-4 4"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionAgenda;